<template>
  <div class="common-scrolling-banner">
    <div class="common-scrolling-banner-title">
      <div class="title-img-container">
        <img :src="LogoNoText" />
      </div>
      <p class="title">Information</p>
    </div>
    <div class="common-scrolling-banner-content">
      <div>
        <span>
          {{ currentText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import LogoNoText from '@/assets/logo-no-text.png'
import { useDataStore } from '@/stores/store_data'

const props = defineProps<{
  texts: string[]
}>()

const store = useDataStore()
const route = useRoute()

const viewOrder = ['electricity', 'solar', 'water', 'waste']

const currentText = computed(() => {
  let index: number
  
  if (route.name === 'data') {
    index = store.getCurrentViewIndex
  } else {
    index = viewOrder.indexOf(route.name as string)
  }
  return index !== -1 ? props.texts[index] || '' : ''
})
</script>

<style lang="scss" scoped>
.common-scrolling-banner {
  height: 50px;
  display: flex;

  &-title {
    display: flex;
    align-items: stretch;
    gap: var(--spacer-0_5);

    .title {
      background-color: var(--vc-gray4);
      align-content: center;
      color: var(--vc-white);
      padding: 0 var(--spacer-0_5);
      border-top-right-radius: var(--br-big);
      border-bottom-right-radius: var(--br-big);
    }
  }

  .title-img-container {
    height: 50px;

    img {
      max-height: 100%;
    }
  }

  &-content {
    flex: 1;
    position: relative;

    div {
      display: flex;
      align-items: center;
      height: 100%;
      top: 0;
      left: calc(0px - var(--spacer));
      position: absolute;
      line-height: 24px;
      background-color: var(--vc-gray3);
      align-content: center;
      padding-left: var(--spacer-2);
      padding-right: var(--spacer-2);
      z-index: -1;
      width: calc(100% + var(--spacer));
      border-top-right-radius: var(--br-big);
      border-bottom-right-radius: var(--br-big);
    }

    span {
      display: block;
    }
  }
}
</style>
